import { oids } from "@/configs/Settings";
import { EndpointConfig } from "./components";

export const endpointConfigs: Record<string, EndpointConfig> = {
    'luxor-medical-report': {
        endpoint: '/luxor_med_relatorio_medico',
        name: 'Relatório Médico',
        description: 'Gera relatórios médicos estruturados de acordo com protocolos clínicos',
        usePractitionerSuffix: false,
        bodyBuilder: async (message: string, organizationId?: string) => ({
            organization: organizationId ? `${oids.cnpj}-${organizationId}` : "",
            message
        })
    },
    'luxor-patient-case-analysis': {
        endpoint: '/luxor_med_discussao_caso',
        name: 'Discussão de Casos',
        description: 'Analisa casos clínicos apresentando evidências e considerações de diagnóstico diferencial',
        usePractitionerSuffix: false,
        bodyBuilder: async (message: string, organizationId?: string) => ({
            organization: organizationId ? `${oids.cnpj}-${organizationId}` : "",
            message: message
        })
    },
    'luxor-patient-guidance': {
        endpoint: '/luxor_med_orientacao_paciente',
        name: 'Orientações ao Paciente',
        description: 'Cria orientações personalizadas para pacientes com base nos dados do atendimento',
        usePractitionerSuffix: false,
        bodyBuilder: async (message: string, organizationId?: string) => ({
            organization: organizationId ? `${oids.cnpj}-${organizationId}` : "",
            message: message
        })
    }
};